module.exports = __webpack_public_path__ + "assets/img/485ac18bb5992fe5b8ac72acf576b229.svg";